export default __webpack_public_path__ + "static/media/CameraIcon.b0d51012.webp";